import type { Client } from '~/api/clients/types';

import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { nameCellStyle } from './clientCell.css';

type Props = {
  client: Client;
};

export const ClientNameCell = ({ client }: Props) => {
  return <span className={clsx(desktopTruncateStyle, nameCellStyle)}>{client.name}</span>;
};
